// extracted by mini-css-extract-plugin
export default {"actions":"drawerfooter_actions__7r1+N","save":"drawerfooter_save__nP1Be"};